import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Cash from './Componet/Cash';
import NavBar from './Navbar/Navbar';
import User from './Componet/user';
import CashResult from './Componet/CashResult';
import UserResult from './Componet/UserResult';

function App() {
  return (
    <BrowserRouter>
      <div>
        <div className="wrapper">
          <div className="header">
            <h1>Project</h1>
            <NavBar />
          </div>
          <Routes>
            <Route path='/' Component={Cash} />
            <Route path='/user' Component={User} />
          </Routes>
        </div>
        <div className="result">
        <Routes>
          <Route path='/' Component={CashResult} />
          <Route path='/user' Component={UserResult} />
        </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
